module.exports = __webpack_public_path__ + "media/comboSmash-preview@md-88289f6e5f790bb4934afd3f693151d7.jpg";